var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangle4354(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 309,
    viewBox: "0 0 280 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.131073 7.40792C0.131073 3.42181 3.36246 0.19043 7.34857 0.19043H271.961C276.185 0.19043 279.506 3.80182 279.153 8.01108L256.405 279.272C256.113 282.751 253.373 285.522 249.897 285.853L8.03285 308.888C3.79556 309.292 0.131073 305.96 0.131073 301.703V7.40792Z",
    fill: "url(#paint0_linear_2514_42857)",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34857 0.788032H271.961C275.835 0.788032 278.882 4.1004 278.558 7.96114L255.81 279.222C255.542 282.413 253.029 284.955 249.841 285.259L7.97619 308.293C4.08975 308.663 0.728676 305.607 0.728676 301.703V7.40792C0.728676 3.75186 3.6925 0.788032 7.34857 0.788032Z",
    stroke: "#FFFBFB",
    strokeOpacity: 0.2,
    strokeWidth: 1.19521
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2514_42857",
    x1: 0.131073,
    y1: 154.916,
    x2: 279.809,
    y2: 154.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E55D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FC3E4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle4354);
export default __webpack_public_path__ + "static/media/rectangle-4354.4c6fe8dbf04bb0567a07bae8bf8a214e.svg";
export { ForwardRef as ReactComponent };